import { ETICHETE_SURSA } from "@/utils/targetareSurse";
import type {
  SurseDate,
  SurseDateBilant,
  SurseDateCaen,
  SurseDateIdentificare,
} from "@/types/identificareFirma";

export type TonSursa = "verde" | "galben" | "neutru";

const AVERTISMENT_ONRC_LOCAL = "ANAF indisponibil, verificați";

export function formatDataScurta(valoare: string | null | undefined): string {
  if (!valoare) return "";
  const data = new Date(valoare);
  if (Number.isNaN(data.getTime())) return "";
  const zi = String(data.getDate()).padStart(2, "0");
  const luna = String(data.getMonth() + 1).padStart(2, "0");
  return `${zi}.${luna}`;
}

export function formatDataCompleta(valoare: string | null | undefined): string {
  if (!valoare) return "";
  const data = new Date(valoare);
  if (Number.isNaN(data.getTime())) return "";
  const zi = String(data.getDate()).padStart(2, "0");
  const luna = String(data.getMonth() + 1).padStart(2, "0");
  return `${zi}.${luna}.${data.getFullYear()}`;
}

export function numeSursa(sursa: string | null | undefined): string {
  if (!sursa) return "";
  return ETICHETE_SURSA[sursa] ?? sursa;
}

export function tonIdentificare(sursa: string | null | undefined): TonSursa {
  if (sursa === "anaf_live" || sursa === "anaf") return "verde";
  if (sursa === "anaf_cache" || sursa === "onrc_local") return "galben";
  return "neutru";
}

export function etichetaIdentificare(
  identificare: SurseDateIdentificare | null | undefined
): string {
  if (!identificare?.sursa) return "";
  const nume = numeSursa(identificare.sursa);

  if (identificare.sursa === "onrc_local") {
    const reper = identificare.snapshot || formatDataCompleta(identificare.la);
    const baza = reper ? `${nume} ${reper}` : nume;
    return `${baza} — ${AVERTISMENT_ONRC_LOCAL}`;
  }

  const data = formatDataCompleta(identificare.la);
  return data ? `${nume} ${data}` : nume;
}

export function etichetaCaen(caen: SurseDateCaen | null | undefined): string {
  if (!caen?.sursa) return "";
  const nume = numeSursa(caen.sursa);
  return caen.snapshot ? `${nume} ${caen.snapshot}` : nume;
}

export function etichetaBilant(
  bilant: SurseDateBilant | null | undefined
): string {
  if (!bilant || bilant.an === null || bilant.sursa === "fara_bilant") {
    return "Fără bilanț";
  }
  const nume = numeSursa(bilant.sursa);
  const publicat = formatDataCompleta(bilant.publicat);
  const detalii = publicat ? `${nume}, publicat ${publicat}` : nume;
  return `Bilanț ${bilant.an} (${detalii})`;
}

export function etichetaSurseDate(surse: SurseDate | null | undefined): string {
  if (!surse) return "";
  const bucati: string[] = [];

  if (surse.identificare?.sursa) {
    const data = formatDataScurta(surse.identificare.la);
    bucati.push(
      data
        ? `${numeSursa(surse.identificare.sursa)} ${data}`
        : numeSursa(surse.identificare.sursa)
    );
  }

  if (surse.caen?.sursa) {
    bucati.push(etichetaCaen(surse.caen));
  }

  if (surse.bilant && surse.bilant.an !== null) {
    bucati.push(`${numeSursa(surse.bilant.sursa)} ${surse.bilant.an}`);
  }

  return bucati.join(" · ");
}
